import { initContract } from '@ts-rest/core'
import z from 'zod'
import { ErrorResponseSchema } from './general'

import type { PostcodeShippingZoneResponseDto} from '@repo/api-types';
import { CourierDeliveryScheduleSchema, ServiceabilitySchema } from '@repo/api-types'

const c = initContract()

export const courierContract = c.router({
  getDeliverySchedules: {
    method: 'GET',
    path: '/couriers/delivery-schedules', // TODO: confirm with ops the endpoint for getting the delivery-schedule
    query: z.object({
      postCode: z.string(),
      suburb: z.string(),
      fromDate: z.string().optional(),
      toDate: z.string().optional(),
    }),
    responses: {
      200: CourierDeliveryScheduleSchema.array(),
      401: ErrorResponseSchema,
    },
  },
  checkServiceability: {
    method: 'POST',
    path: '/couriers/:courierId/serviceable',
    pathParams: z.object({
      courierId: z.string(),
    }),
    body: z.object({
      postcode: z.string(),
      suburb: z.string(),
    }),
    responses: {
      200: ServiceabilitySchema,
      401: ErrorResponseSchema,
    },
  },
  shippingZoneDetails: {
    method: 'GET',
    path: '/couriers/shipping-zone-details',
    query: z.object({
      postcode: z.string(),
    }),
    responses: {
      200: c.type<Omit<PostcodeShippingZoneResponseDto, 'cost' | 'customCost'>>(),
      401: ErrorResponseSchema,
    },
  },
})
